function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgIcSearch = function SvgIcSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.474,0C101.151,0,0,101.151,0,225.474c0,124.33,101.151,225.474,225.474,225.474    c124.33,0,225.474-101.144,225.474-225.474C450.948,101.151,349.804,0,225.474,0z M225.474,409.323    c-101.373,0-183.848-82.475-183.848-183.848S124.101,41.626,225.474,41.626s183.848,82.475,183.848,183.848    S326.847,409.323,225.474,409.323z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.902,476.472L386.574,357.144c-8.131-8.131-21.299-8.131-29.43,0c-8.131,8.124-8.131,21.306,0,29.43l119.328,119.328    c4.065,4.065,9.387,6.098,14.715,6.098c5.321,0,10.649-2.033,14.715-6.098C514.033,497.778,514.033,484.596,505.902,476.472z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_search.c5b786a4.svg";
export { ForwardRef as ReactComponent };